import { render, staticRenderFns } from "./alert_modal.vue?vue&type=template&id=77bf7e96"
import script from "./alert_modal.vue?vue&type=script&lang=js"
export * from "./alert_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports